

import { NgModule } from '@angular/core';
import { TnxSharedModule } from 'tnx-shared';
import { DetailFormFormComponent } from './detailform-form/detailform-form.component';
import { DetailFormComponent } from './detailform.component';
import { DetailFormRoutes } from './detailform.routing';

export function declaration() {
    return [DetailFormComponent, DetailFormFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class DetailFormModule {
}

@NgModule({
    imports: [DetailFormModule, DetailFormRoutes],
    exports: [DetailFormModule]
})
export class DetailFormWithRouteModule {
}
